import React from 'react'
import Link from 'next/link'
import { Sale } from 'src/core/models'
import { CustomCol } from 'src/components'
import { Tooltip, Button, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { getSaleBlockchainCertificate } from 'src/core/helpers'
import { CloudDownloadOutlined, EyeOutlined } from '@ant-design/icons'

const SaleListActions: React.FC<{ sale: Sale }> = ({ sale }) => {
  const { t } = useTranslation()
  const certificateUrl = getSaleBlockchainCertificate(sale)
  const title = certificateUrl === null ? t('Transactions.UnableCertificatex2') : t('Transactions.DownloadCertificate')

  return (
    <Row className='centered-div'>
      <CustomCol xs={12}>
        <a target='_blank' rel='noopener noreferrer' href={certificateUrl}>
          <Tooltip title={title} color={certificateUrl === null ? 'red' : 'blue'}>
            <Button
              type='default'
              shape='circle'
              className='radius-100'
              disabled={certificateUrl === null}
              icon={<CloudDownloadOutlined />}
            />
          </Tooltip>
        </a>
      </CustomCol>
      <CustomCol xs={12}>
        <Link href={`/my-sales/details?id=${sale.id}`} passHref legacyBehavior>
          <a>
            <Tooltip title={t('Transactions.CheckSaleDetails')} color={'blue'}>
              <Button
                shape='circle'
                className='radius-100 ml-2'
                icon={<EyeOutlined />}
              />
            </Tooltip>
          </a>
        </Link>
      </CustomCol>
    </Row>
  )
}

export default SaleListActions
